










































































































































































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {
  HTデータ取込対象一覧取得結果型,
  HTデータ取込対象型,
  日付型,
  日付指定範囲型,
  発注不可型,
  発注卸型, 発注帳票出力依頼型,
  発注未確定一覧取得レコード型,
  発注未確定一覧取得結果型,
  発注未確定削除依頼型,
  発注未確定型,
  発注未確定重複レコード型,
  発注確定送信結果型,
  表示絞込条件型,
  過去発注情報取得結果型,
  過去発注情報型,
  非稼働日一覧型,
} from '@/type/purchaseorder/item';
import {商品オンライン発注可否区分, 商品区分型, 発注入力方法区分型, 使用区分型, 発注処理方法区分, 発注処理結果区分, 発注方法区分型, 並び順一覧, 並び順型} from '@/type/purchaseorder/types';
import {表示用日付} from '@/type/purchaseorder/order-function';
import {非稼働日一覧取得結果型} from '@/type/calendar/non-operation';
import {卸型} from '@/type/wholesale/wholesale';
import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';
import {progress} from '@/script/progress';
import {loginModule} from '@/store/authentication/login';
import {viewEditingStateModule} from '@/store/state/viewEditingState';

import {ValidationResult} from '@/type/validation/result';
import {発注情報バリデータ一覧, 発注未確定絞込条件バリデータ一覧} from '@/type/purchaseorder/order-validate';
import {日付書式} from '@/type/validation/validator';

import ItemSearchDialog from '@/views/purchaseorder/ItemSearchDialog.vue';
import DemandForecastDialog from '@/views/purchaseorder/DemandForecastDialog.vue';
import HistorySearchDialog from '@/views/purchaseorder/HistorySearchDialog.vue';
import HandyImportDialog from '@/views/purchaseorder/HandyImportDialog.vue';
import OrderDuplicateDialog from '@/views/purchaseorder/OrderDuplicateDialog.vue';
import OrderFailureDialog from '@/views/purchaseorder/OrderFailureDialog.vue';
import CodeInputDialog from '@/views/purchaseorder/CodeInputDialog.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import UserSelector from '@/components/user/UserSelector.vue';
import WholesaleSelectorPurchaseOrder from '@/components/wholesale/WholesaleSelectorPurchaseOrder.vue';
import AmountField from '@/components/atom/input/AmountField.vue';
import ToggleButtonField from '@/components/atom/input/ToggleButtonField.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';

import moment from 'moment';

@Component({
  components: {
    Datepicker,
    ItemSearchDialog,
    DemandForecastDialog,
    HistorySearchDialog,
    HandyImportDialog,
    OrderDuplicateDialog,
    OrderFailureDialog,
    CodeInputDialog,
    ButtonPanel,
    IconButton,
    UserSelector,
    WholesaleSelectorPurchaseOrder,
    AmountField,
    ToggleButtonField,
    ConfirmDialog,
    AlertDialog,
    NormalButton,
  },
})

export default class RegisterOrder extends Vue {
  private itemModal: boolean = false;
  private demandModal: boolean = false;
  private historyModal: boolean = false;
  private handyModal: boolean = false;
  private codeModal: boolean = false;
  private duplicateModal: boolean = false;
  private failureModal: boolean = false;
  private 発注卸一覧: 発注卸型[] = [];
  private HTデータ取込対象一覧: HTデータ取込対象型[] = [];
  private 発注未確定リスト: 発注未確定型[] = [];
  private 過去発注情報一覧: 過去発注情報型[] = this.過去発注情報の初期化();
  private 選択中の行index: number|null = null;
  private 発注不可一覧: 発注不可型[] = [];
  private 発注重複商品一覧: 発注未確定重複レコード型[] = [];
  private 発注未確定削除対象: 発注未確定削除依頼型|null = null;
  private 卸変更対象発注未確定index: number = 0;
  private 非稼働日一覧: 非稼働日一覧型 = {
    ほくやく非稼働日リスト: [],
    メディコード非稼働日リスト: [],
    備蓄センター非稼働日リスト: [],
  };

  // TODO 初期値の設定方法はもっといい方法があれば置き換えたい
  private 表示絞込条件: 表示絞込条件型 | null = null;
  private 一括設定発注日: 日付型 = null;
  private 一括設定納品指定日: 日付型 = null;
  // TODO const的な変数の扱いを考える
  private 商品区分一覧: string[] = loginModule.備蓄品の発注が有効である ?
  [
    商品区分型.医薬品,
    商品区分型.その他品,
    商品区分型.備蓄品,
    商品区分型.指定なし,
  ]
  :
  [
    商品区分型.医薬品,
    商品区分型.その他品,
    商品区分型.指定なし,
  ];
  private 発注入力方法区分一覧: string[] = [
    発注入力方法区分型.商品追加,
    発注入力方法区分型.HT追加,
    発注入力方法区分型.定点発注,
    発注入力方法区分型.履歴追加,
    発注入力方法区分型.指定なし,
  ];
  private 使用区分一覧: string[] = [
    使用区分型.その他,
    使用区分型.内服薬,
    使用区分型.注射薬,
    使用区分型.外用薬,
    使用区分型.歯科用薬,
    使用区分型.指定なし,
  ];
  private 発注日納品指定日最大指定日数: number = 89;  // 当日含み90日間

  private アラートメッセージ: string | string[] | null = null;
  private 絞込条件バリデーション結果: ValidationResult = new ValidationResult(発注未確定絞込条件バリデータ一覧);
  private 発注未確定バリデーション結果: ValidationResult = new ValidationResult(発注情報バリデータ一覧);

  private 絞込条件項目表示: boolean = false;

  @Watch('発注未確定リスト', {deep: true})
  private リストが変更された() {
    viewEditingStateModule.画面の編集を開始する();
  }

  get 並び順一覧(): 並び順型[] {
    return 並び順一覧;
  }

  get 表の高さのstyle() {
    let offset = 0;
    if (this.絞込条件項目表示) offset = offset + 100;
    offset = 485 + offset;
    return {
      height: `calc(100vh - ${offset}px)`,
    };
  }

  private get 表示件数を取得() {
    return this.発注未確定リスト.length;
  }

  private get 納品指定日消去の確認() {
    const 対象発注未確定 = this.発注未確定リスト.find((発注未確定: 発注未確定型) => {
                return 発注未確定.納品指定日 !== null && this.納品指定日の設定不可(発注未確定);
              });
    if (対象発注未確定 === undefined) {
      return '';
    }

    return '納品日を指定できない卸は納品指定日がクリアされます。';
  }

  private created() {
    this.initialize();
    this.getWholesaleList();
    this.getHandyList();
    this.getNonOperationList();
    this.getList();
  }

  private initialize() {
    viewEditingStateModule.初期化する();

    this.表示絞込条件 = {
      データ登録者アカウント: null,
      卸コード: '',
      商品区分: 商品区分型.指定なし,
      発注入力方法区分: 発注入力方法区分型.指定なし,
      使用区分: 使用区分型.指定なし,
      メーカー名検索文字列: '',
      商品名カナ検索文字列: '',
      発注日開始日付: null,
      発注日終了日付: null,
      納品予定日開始日付: null,
      納品予定日終了日付: null,
      並び順条件第1項目: '指定なし',
      並び順条件第2項目: '指定なし',
      並び順条件第3項目: '指定なし',
    };

    if (!loginModule.管理者である) {
      this.表示絞込条件.データ登録者アカウント = loginModule.利用者コードを取得する;
    }
  }

  private beforeUpdate(): void {
    this.絞込条件バリデーション結果.validate(this.表示絞込条件);
    this.発注未確定バリデーション結果.validateList(this.発注未確定リスト);
  }

  private 絞込条件入力エラー判定表示(項目名: string) {
    return {'input-error': this.絞込条件入力エラー判定(項目名)};
  }

  private 絞込条件入力エラー判定(項目名: string): boolean {
    return this.絞込条件バリデーション結果.hasError(項目名);
  }

  private 発注未確定エラー判定(index: number, 項目名: string): boolean {
    return this.発注未確定バリデーション結果.hasError(項目名, index);
  }

  private async getWholesaleList() {
    await api.卸一覧を取得する()
    .then((response: 卸型[]) => {
      this.発注卸一覧 = response.map((卸: 卸型) => {
        return {
          卸コード: 卸.卸コード,
          卸名: 卸.卸名,
          納品予定指定可能日数: 卸.納品予定指定可能日数,
          オンライン発注可能: (卸.EOS卸コード !== null && 卸.EOS卸コード.length !== 0) ? true : false,
          医薬品発注可能: 卸.医薬品発注有効区分 === '有効' ? true : false,
          その他品発注可能: 卸.その他品発注有効区分 === '有効' ? true : false,
          備蓄品発注可能: (卸.備蓄品発注有効区分 === '有効' && 卸.備蓄センターフラグ === '備蓄センター') ? true : false,
          ほくやくである: 卸.ほくやくフラグ === 'ほくやく' ? true : false,
          備蓄センターである: 卸.備蓄センターフラグ === '備蓄センター' ? true : false,
        };
      });

    }).catch((error: any) => {
      this.APIアラートダイアログを開く(error.data);
      return;
    });
  }

  private async getHandyList() {
    await api.HTデータ取込対象一覧を取得する()
    .then((response: HTデータ取込対象一覧取得結果型) => {
      this.HTデータ取込対象一覧 = response.ハンディデータ取込対象リスト;
      this.HTデータ取込対象一覧.push({ 機械番号: '', 端末名: '指定なし' });

    }).catch((error: any) => {
      this.APIアラートダイアログを開く(error.data);
      return;
    });
  }

  private async getNonOperationList() {
    const 非稼働日一覧取得依頼 = {
      取得開始日: moment().format('YYYY-MM-DD'),
      取得終了日: moment().add(this.発注日納品指定日最大指定日数, 'days').format('YYYY-MM-DD'),
    };
    await api.非稼働日を取得する(非稼働日一覧取得依頼)
    .then((response: 非稼働日一覧取得結果型) => {
      this.非稼働日一覧.ほくやく非稼働日リスト = response.ほくやく非稼働日リスト.map((日付: string) => {
        return new Date(日付);
      });
      this.非稼働日一覧.メディコード非稼働日リスト = response.メディコード非稼働日リスト.map((日付: string) => {
        return new Date(日付);
      });
      this.非稼働日一覧.備蓄センター非稼働日リスト = response.備蓄センター非稼働日リスト.map((日付: string) => {
        return new Date(日付);
      });

    }).catch((error: any) => {
      this.APIアラートダイアログを開く(error.data);
      return;
    });
  }

  private async getList() {
    await this.getListMain()
    .then((response: any) => {
      viewEditingStateModule.画面の編集を終了する();
    }).catch((error: any) => {
      return;
    });
  }

  private async getListMain(): Promise<void> {
    if (!this.表示絞込条件) { return; }

    const 発注未確定一覧取得依頼 = {
      データ登録者アカウント: this.表示絞込条件.データ登録者アカウント,
      卸コード: this.表示絞込条件.卸コード,
      商品区分: this.表示絞込条件.商品区分 === 商品区分型.指定なし ? null : this.表示絞込条件.商品区分,
      発注入力方法区分: this.表示絞込条件.発注入力方法区分 === 発注入力方法区分型.指定なし ? null : this.表示絞込条件.発注入力方法区分,
      使用区分: this.表示絞込条件.使用区分 === 使用区分型.指定なし ? null : this.表示絞込条件.使用区分,
      メーカー名検索文字列: this.表示絞込条件.メーカー名検索文字列,
      商品名カナ検索文字列: this.表示絞込条件.商品名カナ検索文字列,
      発注日開始日付: this.表示絞込条件.発注日開始日付,
      発注日終了日付: this.表示絞込条件.発注日終了日付,
      納品予定日開始日付: this.表示絞込条件.納品予定日開始日付,
      納品予定日終了日付: this.表示絞込条件.納品予定日終了日付,
      並び順条件第1項目: this.表示絞込条件.並び順条件第1項目,
      並び順条件第2項目: this.表示絞込条件.並び順条件第2項目,
      並び順条件第3項目: this.表示絞込条件.並び順条件第3項目,
    };

    await api.発注未確定一覧を取得する(発注未確定一覧取得依頼)
    .then((response: 発注未確定一覧取得結果型) => {
      this.発注未確定リスト = response.発注未確定一覧取得レコードリスト.map((取得商品: 発注未確定一覧取得レコード型) => {
        return {
          選択: true,
          メーカー名: 取得商品.メーカー名,
          商品名: 取得商品.商品名,
          規格容量: 取得商品.規格容量,
          卸コード: 取得商品.卸コード,
          発注数: 取得商品.発注数,
          前回発注数: 取得商品.前回発注数,
          発注単位: 取得商品.発注単位名,
          発注日: this.日付型を取得(取得商品.発注日),
          納品指定日: this.日付型を取得(取得商品.納品指定日),
          発注方法: 取得商品.発注方法区分,
          商品区分: 取得商品.商品区分,
          入力方法: 取得商品.発注入力方法区分,
          データ登録者: 取得商品.データ登録者,
          商品コード: 取得商品.商品コード,
          発注未確定シーケンス番号: 取得商品.発注未確定シーケンス番号,
          更新バージョン: 取得商品.更新バージョン,
          オンライン発注可否区分: 取得商品.オンライン発注可否区分,
        };
      });

      this.選択中の行index = null;
      this.過去発注情報一覧 = this.過去発注情報の初期化();

      if (response.アラートメッセージ) {
        this.アラートメッセージ = response.アラートメッセージ;
        this.$modal.show('アラート');
      }

    }).catch((error: any) => {
      this.APIアラートダイアログを開く(error.data);
      return Promise.reject();
    });
  }

  private 日付型を取得(日付: string): 日付型 {
    if (日付 === null || 日付.length === 0) {
      return null;
    }
    return new Date(日付);
  }

  private async 発注検索を実行するハンドラ() {
    if (this.絞込条件バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.絞込条件バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }

    if (viewEditingStateModule.画面を編集中である) {
      this.ダイアログを開く('編集中絞込検索確認ダイアログ');
      return;
    }

    await progress(this.getList);
  }

  private async 編集を破棄して発注検索を実行するハンドラ() {
    this.ダイアログを閉じる('編集中絞込検索確認ダイアログ');
    viewEditingStateModule.画面の編集を終了する();
    await progress(this.getList);
  }

  private 発注未確定の保存を確認する() {
    if (this.発注データが0件()) {
      return;
    }

    if (this.発注未確定バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.発注未確定バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }

    this.ダイアログを開く('保存ダイアログ');
  }

  private async 発注未確定を保存するハンドラ() {
    this.ダイアログを閉じる('保存ダイアログ');
    await progress(this.発注未確定を保存する);
  }

  private async 発注未確定を保存する(): Promise<void> {
    await this.発注未確定の保存()
    .then((response: any) => {
      // NOTE サーバ側で確定する値があるため保存後に再読み込みする
      this.getList();
    }).catch((error: any) => {
      return;
    });
  }

  private async 発注未確定の保存(): Promise<void> {
    const 発注未確定更新リスト = this.発注未確定リスト.map((発注未確定: 発注未確定型) => {
      return {
        発注未確定シーケンス番号: 発注未確定.発注未確定シーケンス番号,
        卸コード: 発注未確定.卸コード,
        発注数: 発注未確定.発注数,
        発注日: 発注未確定.発注日,
        納品指定日: (発注未確定.納品指定日 !== null && this.納品指定日の設定不可(発注未確定)) ? null : 発注未確定.納品指定日,
        発注方法: 発注未確定.発注方法,
        更新バージョン: 発注未確定.更新バージョン,
      };
    });

    const 発注未確定更新依頼 = {
      発注未確定更新レコードリスト: 発注未確定更新リスト,
    };

    await api.発注未確定を保存する(発注未確定更新依頼)
    .catch((error: any) => {
      this.APIアラートダイアログを開く(error.data);
      return Promise.reject();
    });

    return Promise.resolve();
  }

  private 発注の確定送信を確認する() {
    if (this.発注データが0件()) {
      return;
    }

    if (this.発注未確定バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.発注未確定バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }

    const 発注確定送信リスト = this.発注未確定リスト
              .filter((発注未確定: 発注未確定型) => {
                return 発注未確定.選択;
              });

    if (発注確定送信リスト.length === 0) {
      this.アラートメッセージ = '発注する商品が選択されていません';
      this.$modal.show('アラート');
      return;
    }

    this.ダイアログを開く('確定送信ダイアログ');
  }

  private async 発注を確定送信するハンドラ() {
    this.ダイアログを閉じる('確定送信ダイアログ');
    await progress(this.発注を確定送信する)
    .catch((error: any) => {
      return;
    });
  }

  private async 発注を確定送信する(): Promise<void> {
    const 発注確定送信リスト = this.発注未確定リスト
              .filter((発注未確定: 発注未確定型) => {
                return 発注未確定.選択;
              })
              .map((発注未確定: 発注未確定型) => {
                return {
                  発注未確定シーケンス番号: 発注未確定.発注未確定シーケンス番号,
                };
              });

    await this.発注未確定の保存()
    .catch((error: any) => {
      return Promise.reject();
    });

    const 発注確定送信依頼 = {
      発注処理方法区分: 発注処理方法区分.重複確認して発注する,
      発注レコードリスト: 発注確定送信リスト,
    };

    await api.発注を確定送信する(発注確定送信依頼)
    .then((response: 発注確定送信結果型) => {
      if (response.発注結果 === 発注処理結果区分.重複発注商品あり) {
        this.発注重複商品一覧 = response.発注未確定重複一覧;
        this.重複警告ダイアログを開く();
        return Promise.reject();
      }

      this.発注不可一覧 = response.発注不可一覧;
      if (this.発注不可一覧.length !== 0) {
        this.発注不可商品ダイアログを開く();
      }

      const 全発注伝票番号一覧 = response.オンライン発注伝票番号一覧
                        .concat(response.FAX発注伝票番号一覧)
                        .concat(response.電話発注伝票番号一覧);
      if (全発注伝票番号一覧.length === 0) {
        this.メッセージ指定してアラートダイアログを開く('確定した商品は１件もありませんでした');
      }

      if (loginModule.発注書の自動表示が有効である) {
        if (全発注伝票番号一覧.length !== 0) {
          const 発注帳票出力依頼 = {
                発注伝票番号一覧: 全発注伝票番号一覧,
          };
          download.発注書帳票を表示する(発注帳票出力依頼);
        }
      } else {
        if (response.FAX発注伝票番号一覧.length !== 0) {
          const 発注帳票出力依頼 = {
                発注伝票番号一覧: response.FAX発注伝票番号一覧,
          };
          download.発注書帳票を出力する('発注書.pdf', 発注帳票出力依頼);
        }
      }

      this.getList();

    }).catch((error: any) => {
      this.APIアラートダイアログを開く(error.data);
      return;
    });
  }

  private async 発注を重複確認なしで確定送信するハンドラ() {
    await progress(this.発注を重複確認なしで確定送信する);
  }

  private async 発注を重複確認なしで確定送信する(): Promise<void> {
    const 発注確定送信リスト = this.発注未確定リスト
              .filter((発注未確定: 発注未確定型) => {
                return 発注未確定.選択;
              })
              .map((発注未確定: 発注未確定型) => {
                return {
                  発注未確定シーケンス番号: 発注未確定.発注未確定シーケンス番号,
                };
              });

    const 発注確定送信依頼 = {
      発注処理方法区分: 発注処理方法区分.発注する,
      発注レコードリスト: 発注確定送信リスト,
    };


    await api.発注を確定送信する(発注確定送信依頼)
    .then((response: 発注確定送信結果型) => {
      this.発注不可一覧 = response.発注不可一覧;
      if (this.発注不可一覧.length !== 0) {
        this.発注不可商品ダイアログを開く();
      }

      const 発注帳票出力依頼 = this.発注帳票出力依頼を作成する(response);

      if (発注帳票出力依頼.発注伝票番号一覧.length !== 0) {
        this.発注書を表示または出力する(発注帳票出力依頼);
      }

      this.getList();

    }).catch((error: any) => {
      this.APIアラートダイアログを開く(error.data);
      return;
    });
  }

  private 発注帳票出力依頼を作成する(response: 発注確定送信結果型): 発注帳票出力依頼型 {
    const 発注帳票出力依頼 = {
      発注伝票番号一覧: loginModule.発注書の自動表示が有効である ?
          response.オンライン発注伝票番号一覧.concat(response.FAX発注伝票番号一覧).concat(response.電話発注伝票番号一覧)
          : response.FAX発注伝票番号一覧,
    };
    return 発注帳票出力依頼;
  }

  private 発注書を表示または出力する(発注帳票出力依頼: 発注帳票出力依頼型): void {
    if (loginModule.発注書の自動表示が有効である) {
      download.発注書帳票を表示する(発注帳票出力依頼);
      return;
    }
    download.発注書帳票を出力する('発注書.pdf', 発注帳票出力依頼);
  }

  private 発注未確定の削除を確認する(発注未確定: 発注未確定型) {
    this.発注未確定削除対象 = {
      発注未確定シーケンス番号: 発注未確定.発注未確定シーケンス番号,
      更新バージョン: 発注未確定.更新バージョン,
    };

    if (viewEditingStateModule.画面を編集中である) {
      this.ダイアログを開く('編集中削除ダイアログ');
      return;
    }

    this.ダイアログを開く('削除ダイアログ');
  }

  private 削除ダイアログを閉じる() {
    this.発注未確定削除対象 = null;
    this.ダイアログを閉じる('削除ダイアログ');
  }

  private 編集中削除ダイアログを閉じる() {
    this.発注未確定削除対象 = null;
    this.ダイアログを閉じる('編集中削除ダイアログ');
  }

  private async 発注未確定を削除するハンドラ() {
    this.ダイアログを閉じる('削除ダイアログ');
    await progress(this.発注未確定を削除する)
    .catch((error: any) => {
      return;
    });
  }

  private async 編集を破棄して発注未確定を削除するハンドラ() {
    this.ダイアログを閉じる('編集中削除ダイアログ');
    viewEditingStateModule.画面の編集を終了する();
    await progress(this.発注未確定を削除する)
    .catch((error: any) => {
      return;
    });
  }

  private async 発注未確定を削除する(): Promise<void> {
    if (this.発注未確定削除対象 === null) {
      return;
    }

    await api.発注未確定を削除する(this.発注未確定削除対象)
    .catch((error: any) => {
      return Promise.reject();
    });

    this.発注未確定削除対象 = null;

    // NOTE 削除された発注は未確定から消えるため再読み込みする
    this.getList();
  }

  private 優先卸の変更を確認する(index: number, 商品コード: string) {
    this.卸変更対象発注未確定index = index;
    if (商品コード === null || 商品コード === undefined || 商品コード.length === 0) {
      this.卸変更後の処理();
    } else {
      this.ダイアログを開く('優先卸変更ダイアログ');
    }
  }

  private 卸変更後の処理() {
    this.ダイアログを閉じる('優先卸変更ダイアログ');

    if (!this.オンライン発注可能(this.発注未確定リスト[this.卸変更対象発注未確定index])) {
      this.発注未確定リスト[this.卸変更対象発注未確定index].発注方法 = 発注方法区分型.FAX;
    }
  }

  private async 優先卸を変更するハンドラ() {
    this.ダイアログを閉じる('優先卸変更ダイアログ');
    await progress(this.優先卸を変更する);
  }

  private async 優先卸を変更する() {
    const 優先卸変更依頼型 = {
      卸コード: this.発注未確定リスト[this.卸変更対象発注未確定index].卸コード,
      商品コード: this.発注未確定リスト[this.卸変更対象発注未確定index].商品コード,
    };

    await api.優先卸を変更する(優先卸変更依頼型)
    .catch((error: any) => {
      this.APIアラートダイアログを開く(error.data);
    });

    this.卸変更後の処理();
  }

  private async リスト選択時の処理(発注未確定: 発注未確定型, index: number) {
    if (this.選択中の行index !== index) {
      this.選択中の行index = index;
      this.過去発注情報の取得(発注未確定.商品コード);
    }
  }

  private async 過去発注情報の取得(商品コード: string) {
    if (商品コード === null || 商品コード === '') {
      this.過去発注情報一覧 = this.過去発注情報の初期化();
      return;
    }

    await api.過去発注情報を取得する(商品コード)
    .then((response: 過去発注情報取得結果型) => {
      this.過去発注情報一覧 = response.過去発注情報取得結果レコードリスト.map((過去発注情報: 過去発注情報型) => {
        return {
          発注日: 表示用日付(過去発注情報.発注日),
          発注確定時刻: 過去発注情報.発注確定時刻,
          発注数: 過去発注情報.発注数,
          卸名: 過去発注情報.卸名,
        };
      });

    }).catch((error: any) => {
      this.APIアラートダイアログを開く(error.data);
      return;
    });
  }

  private 行が選択されている(index: number) {
    return this.選択中の行index === index;
  }

  // TODO 初期化の方法は要検討
  private 過去発注情報の初期化(): 過去発注情報型[] {
    return [
      { 発注日: '',
        発注確定時刻: '',
        発注数: null,
        卸名: '',
      },
      { 発注日: '',
        発注確定時刻: '',
        発注数: null,
        卸名: '',
      },
      { 発注日: '',
        発注確定時刻: '',
        発注数: null,
        卸名: '',
      },
    ];
  }

  private 重複警告ダイアログを開く() {
    this.duplicateModal = true;
  }

  private 重複警告ダイアログを閉じる() {
    this.duplicateModal = false;
    this.発注重複商品一覧 = [];
    this.getList();
  }

  private 重複警告ダイアログを閉じて重複確認なしで発注する() {
    this.duplicateModal = false;
    this.発注重複商品一覧 = [];
    this.発注を重複確認なしで確定送信するハンドラ();
  }

  private 発注不可商品ダイアログを開く() {
    this.failureModal = true;
  }

  private 発注不可商品ダイアログを閉じる() {
    this.failureModal = false;
    this.発注不可一覧 = [];
  }

  private 商品追加ダイアログを開く() {
    if (viewEditingStateModule.画面を編集中である) {
      this.ダイアログを開く('編集中商品追加確認ダイアログ');
      return;
    }

    this.itemModal = true;
  }

  private 定点発注ダイアログを編集を破棄して開く() {
    this.ダイアログを閉じる('編集中定点発注確認ダイアログ');
    viewEditingStateModule.画面の編集を終了する();
    this.demandModal = true;
  }

  private 定点発注ダイアログを閉じる() {
    this.demandModal = false;
    this.getList();
  }

  private 定点発注ダイアログを開く() {
    if (viewEditingStateModule.画面を編集中である) {
      this.ダイアログを開く('編集中定点発注確認ダイアログ');
      return;
    }

    this.demandModal = true;
  }

  private 商品追加ダイアログを編集を破棄して開く() {
    this.ダイアログを閉じる('編集中商品追加確認ダイアログ');
    viewEditingStateModule.画面の編集を終了する();
    this.itemModal = true;
  }

  private 商品追加ダイアログを閉じる() {
    this.itemModal = false;
    this.getList();
  }

  private 履歴追加ダイアログを開く() {
    if (viewEditingStateModule.画面を編集中である) {
      this.ダイアログを開く('編集中履歴追加確認ダイアログ');
      return;
    }

    this.historyModal = true;
  }

  private 履歴追加ダイアログを編集を破棄して開く() {
    this.ダイアログを閉じる('編集中履歴追加確認ダイアログ');
    viewEditingStateModule.画面の編集を終了する();
    this.historyModal = true;
  }

  private 履歴追加ダイアログを閉じる() {
    this.historyModal = false;
    this.getList();
  }

  private HTデータ取込ダイアログを開く() {
    if (viewEditingStateModule.画面を編集中である) {
      this.ダイアログを開く('編集中HTデータ取込確認ダイアログ');
      return;
    }

    this.handyModal = true;
  }

  private HTデータ取込ダイアログを編集を破棄してを開く() {
    this.ダイアログを閉じる('編集中HTデータ取込確認ダイアログ');
    viewEditingStateModule.画面の編集を終了する();
    this.handyModal = true;
  }

  private HTデータ取込ダイアログを閉じる() {
    this.handyModal = false;
    this.getList();
  }

  private コード入力ダイアログを開く() {
    if (viewEditingStateModule.画面を編集中である) {
      this.ダイアログを開く('編集中コード入力確認ダイアログ');
      return;
    }

    this.codeModal = true;
  }

  private コード入力ダイアログを編集を破棄して開く() {
    this.ダイアログを閉じる('編集中コード入力確認ダイアログ');
    viewEditingStateModule.画面の編集を終了する();
    this.codeModal = true;
  }

  private コード入力ダイアログを閉じる() {
    this.codeModal = false;
    this.getList();
  }

  private ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  private ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  private アラートダイアログを開く(event: Event) {
    this.アラートメッセージ = event.toString().split(',');
    this.$modal.show('アラート');
  }

  private メッセージ指定してアラートダイアログを開く(message: string) {
    this.アラートメッセージ = [message];
    this.$modal.show('アラート');
  }

  private APIアラートダイアログを開く(data: any) {
      this.アラートメッセージ = [data.message];
      if (data.errors !== null && data.errors !== undefined) {
        for (const エラー of data.errors) {
          this.アラートメッセージ = this.アラートメッセージ.concat(['・' + エラー]);
        }
      }
      this.$modal.show('アラート');
  }

  private 発注データが0件(): boolean {
    return this.発注未確定リスト.length === 0;
  }

  private 納品指定日の設定不可(発注未確定: 発注未確定型): boolean {
    const 発注卸 = this.発注卸一覧
              .find((卸: 発注卸型) => {
                return 卸.卸コード === 発注未確定.卸コード;
              });
    return (発注卸 !== undefined && (発注卸.納品予定指定可能日数 === 0 || 発注卸.備蓄センターである));
  }

  private オンライン発注可能(発注未確定: 発注未確定型): boolean {
    const 発注卸 = this.発注卸一覧
              .find((卸: 発注卸型) => {
                return 卸.卸コード === 発注未確定.卸コード;
              });
    return (発注卸 !== undefined && 発注卸.オンライン発注可能 && this.商品のオンライン発注が可能(発注未確定));
  }

  private 納品予定指定可能日数を取得(卸コード: string): number {
    const 発注卸 = this.発注卸一覧
              .find((卸: 発注卸型) => {
                return 卸.卸コード === 卸コード;
              });

    if (発注卸 !== undefined) {
      return 発注卸.納品予定指定可能日数;
    }

    return 14;
  }

  private 商品のオンライン発注が可能(発注未確定: 発注未確定型) {
    return 発注未確定.オンライン発注可否区分 === 商品オンライン発注可否区分.発注可能;
  }

  private 一括設定発注日の指定範囲を取得(): 日付指定範囲型 {
    // NOTE: 個別の発注日に対する考慮が出来ないため当日以降を選択可能としておく
    return {
      to: moment().startOf('day').toDate(),
      from: moment().startOf('day').add(this.発注日納品指定日最大指定日数, 'days').toDate(),
      dates: [],
    };
  }

  private 発注日の指定範囲を取得(発注未確定: 発注未確定型): 日付指定範囲型 {
    return {
      to: moment().startOf('day').toDate(),
      from: moment().startOf('day').add(this.発注日納品指定日最大指定日数, 'days').toDate(),
      dates: this.該当卸の非稼働日を取得(発注未確定.卸コード),
    };
  }

  private 一括設定納品指定日の指定範囲を取得(): 日付指定範囲型 {
    // NOTE: 個別の発注日に対する考慮が出来ないため翌日or一括発注日以降を選択可能としておく
    return {
      to: this.一括設定発注日 === null ? moment().startOf('day').add(1, 'days').toDate() :
              moment(this.一括設定発注日).startOf('day').add(1, 'days').toDate(),
      from: moment().startOf('day').add(this.発注日納品指定日最大指定日数, 'days').toDate(),
      dates: [],
    };
  }

  private 納品指定日の指定範囲を取得(発注未確定: 発注未確定型): 日付指定範囲型 {
    const 納品予定指定可能日数 = this.納品予定指定可能日数を取得(発注未確定.卸コード);
    return this.納品指定日の指定範囲を生成(発注未確定.発注日, 納品予定指定可能日数, 発注未確定.卸コード);
  }

  private 納品指定日の指定範囲を生成(発注日: 日付型, 納品予定指定可能日数: number, 卸コード: string): 日付指定範囲型 {
    if ((発注日 == null) || !日付書式(発注日)) {
      return {
        to: moment().startOf('day').add(1, 'days').toDate(),
        from: this.納品指定日の指定可能日を取得(moment().startOf('day').add(納品予定指定可能日数, 'days').toDate()),
        dates: this.該当卸の非稼働日を取得(卸コード),
      };
    }

    return {
      to: moment(発注日).startOf('day').add(1, 'days').toDate(),
      from: this.納品指定日の指定可能日を取得(moment(発注日).startOf('day').add(納品予定指定可能日数, 'days').toDate()),
      dates: this.該当卸の非稼働日を取得(卸コード),
    };
  }

  private 納品指定日の指定可能日を取得(日付: Date): Date {
    const 最大指定可能日付 = moment().add(this.発注日納品指定日最大指定日数, 'days').toDate();
    if (日付.getTime() < 最大指定可能日付.getTime()) {
      return 日付;
    } else {
      return 最大指定可能日付;
    }
  }

  private 該当卸の非稼働日を取得(卸コード: string): Date[] {
    if (this.非稼働日一覧 === null) {
      return [];
    }

    const 発注卸 = this.発注卸一覧
              .find((卸: 発注卸型) => {
                return 卸.卸コード === 卸コード;
              });

    if (発注卸 === null || 発注卸 === undefined) {
      return [];
    } else if (発注卸.ほくやくである) {
      return this.非稼働日一覧.ほくやく非稼働日リスト;
    } else if (発注卸.備蓄センターである) {
      return this.非稼働日一覧.備蓄センター非稼働日リスト;
    } else {
      return this.非稼働日一覧.メディコード非稼働日リスト;
    }
  }

  private 発注日を一括指定する() {
    if (this.一括設定発注日 != null && !日付書式(this.一括設定発注日)) {
      this.アラートメッセージ = '発注日(全指定)の書式が不正です';
      this.$modal.show('アラート');
      return;
    }

    this.発注未確定リスト = this.発注未確定リスト.map((発注未確定: 発注未確定型) => {
        return {
          選択: 発注未確定.選択,
          メーカー名: 発注未確定.メーカー名,
          商品名: 発注未確定.商品名,
          規格容量: 発注未確定.規格容量,
          卸コード: 発注未確定.卸コード,
          発注数: 発注未確定.発注数,
          発注単位: 発注未確定.発注単位,
          発注日: this.一括設定発注日,
          納品指定日: 発注未確定.納品指定日,
          発注方法: 発注未確定.発注方法,
          商品区分: 発注未確定.商品区分,
          入力方法: 発注未確定.入力方法,
          データ登録者: 発注未確定.データ登録者,
          商品コード: 発注未確定.商品コード,
          発注未確定シーケンス番号: 発注未確定.発注未確定シーケンス番号,
          更新バージョン: 発注未確定.更新バージョン,
          オンライン発注可否区分: 発注未確定.オンライン発注可否区分,
        };
    });
  }

  private 納品指定日を一括指定する() {
    if (this.一括設定納品指定日 != null && !日付書式(this.一括設定納品指定日)) {
      this.アラートメッセージ = '納品指定日(全指定)の書式が不正です';
      this.$modal.show('アラート');
      return;
    }

    this.発注未確定リスト = this.発注未確定リスト.map((発注未確定: 発注未確定型) => {
      if (発注未確定.商品区分 === 商品区分型.備蓄品) {
        return 発注未確定;
      }
      return {
        選択: 発注未確定.選択,
        メーカー名: 発注未確定.メーカー名,
        商品名: 発注未確定.商品名,
        規格容量: 発注未確定.規格容量,
        卸コード: 発注未確定.卸コード,
        発注数: 発注未確定.発注数,
        発注単位: 発注未確定.発注単位,
        発注日: 発注未確定.発注日,
        納品指定日: this.一括設定納品指定日,
        発注方法: 発注未確定.発注方法,
        商品区分: 発注未確定.商品区分,
        入力方法: 発注未確定.入力方法,
        データ登録者: 発注未確定.データ登録者,
        商品コード: 発注未確定.商品コード,
        発注未確定シーケンス番号: 発注未確定.発注未確定シーケンス番号,
        更新バージョン: 発注未確定.更新バージョン,
        オンライン発注可否区分: 発注未確定.オンライン発注可否区分,
      };
    });
  }

  private 発注方法を一括FAXにする() {
    this.発注未確定リスト = this.発注未確定リスト.map((発注未確定: 発注未確定型) => {
      return {
        選択: 発注未確定.選択,
        メーカー名: 発注未確定.メーカー名,
        商品名: 発注未確定.商品名,
        規格容量: 発注未確定.規格容量,
        卸コード: 発注未確定.卸コード,
        発注数: 発注未確定.発注数,
        発注単位: 発注未確定.発注単位,
        発注日: 発注未確定.発注日,
        納品指定日: 発注未確定.納品指定日,
        発注方法: 'FAX',
        商品区分: 発注未確定.商品区分,
        入力方法: 発注未確定.入力方法,
        データ登録者: 発注未確定.データ登録者,
        商品コード: 発注未確定.商品コード,
        発注未確定シーケンス番号: 発注未確定.発注未確定シーケンス番号,
        更新バージョン: 発注未確定.更新バージョン,
        オンライン発注可否区分: 発注未確定.オンライン発注可否区分,
      };
    });
  }
  private 在庫管理を行う(): boolean {
    return loginModule.システム利用区分が発注と在庫管理である;
  }

  private 絞込条件の表示を切り替える(): void {
    this.絞込条件項目表示 = !this.絞込条件項目表示;
  }
}
